module.exports = {
  DestinationDistribution: '配送先コード',
  ExpressCompany: 'Express Company',
  ExpressNo: ' 速達番号',
  ElectricCol: 'Electric',
  MagneticCol: 'Magnetic',
  UseNewNo: 'Generated New No',
  BookingAudit: 'Booking Audit',
  ShippingType: 'Shipping Type',
  overseaWarehouse: 'Oversea warehouse',
  LclMethod: 'Lcl method',
  IncoTerm: 'Inco Term',
  VolumetricWeight: 'Volume (Contract)',
  ChargedWeight: 'Charged Weight (Contract)',
  DomesticWarehouse: 'Domestic warehouse',
  importSingleOrder: 'Import single order',
  batchImportOrder: 'Batch import order',
  downloadSingleImportTemplate: 'Download single import template',
  downloadBatchImportTemplate: 'Download batch import template',
  ServiceChannel: 'Service Channel',
  ChargingMethod: 'Charging Method',
  BubbleCountingRatio: 'Bubble Counting',
  BubbleSplittingRatio: 'Bubble Splitting',
  ShippingTypeCannotBeEmpty: 'Shipping Type Cannot Be Empty',
  DomesticWarehouseCannotBeEmpty: 'Domestic Warehouse Cannot Be Empty',
  WarehouseCodeCannotBeEmpty: 'Warehouse Code Cannot Be Empty',
  ContainerLoadTypeCannotBeEmpty: 'Container Load Type Cannot Be Empty',
  OperateTypeCannotBeEmpty: 'Operate Type Cannot Be Empty',
  BookingTermCannotBeEmpty: 'Booking Term Cannot Be Empty',
  ChargingMethodCannotBeEmpty: 'Charging Method Cannot Be Empty',
  PowderyCol: 'Powder',
  SingleImport: 'Import an FBA order',
  LiquidCol: 'Liquid',
  RemoteWarehouse: 'リモート倉庫',
  AmazonWarehouseCode: 'Amazon倉庫コード',
  OperationStatusOfForeignWarehouse: 'Operation status of foreign warehouse',
  Cargo_PolStation: 'Departure station',
  quotationStatus: 'Quotation Status',
  quotationObject: 'Quotation Object',
  hasJob: 'Has Job',
  ShipmentId: '出荷ID',
  ReferenceId: '参照ID',
  cannotDeleteAddedService: 'It is not allowed to delete value-added services that have been used by the business!',
  changeChannel: 'The current service channel does not maintain the quotation at the current customer level, and the system cannot automatically estimate the cost. Do you want to continue?',
  cargoTypeNotExist: 'The available cargo of the current service channel does not contain {0}, please update the cargo type!',
  warehouseCodeNotExist: 'The destination of the current service channel does not contain {0}, please update the destination!',
  refreshCharge: 'If the service channel is changed, do I need to refresh the original fee generated according to the service channel?',
  changeWarehouseCode: 'If the destination is changed, do you want to refresh the fees incurred in the area where the original service channel is located?',
  changeCustomer: 'Does the change of entrusting unit refresh the expenses generated by the customer level of the original service channel?',
  changeChargeWeight: 'If the billing weight is changed, do you want to refresh the original fee based on the billing weight? Fees that have been billed, invoiced, payment application, and written off will not be updated',
  channelInfoCannotChange: '{0} for this service channel cannot be modified.',
  changeVerifyShippingType: '{0} this service channel only supports {1} shipping.',
  changeVerifyMultipleShippingType: 'Check the order data that contains the maintenance service channel, and the shipping method cannot be modified.',
  otherOverseaWarehouse: 'Third Party Overseas Warehouses'
}
